import { render, staticRenderFns } from "./productBatchEdit.vue?vue&type=template&id=167ebc58&"
import script from "./productBatchEdit.vue?vue&type=script&lang=ts&"
export * from "./productBatchEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports